import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { client } from '../../api/client'


export const getCookie = (cname) => {
    var name = cname + "="
    var ca = decodeURIComponent(document.cookie).split(';')
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) === ' ') {
            c = c.substring(1)
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length)
        }
    }
    return ""
}

export const setCookie = (cname, cvalue, exdays) => {
    var d = new Date()
    if (exdays === null || exdays === "")
        return document.cookie = cname + "=" + cvalue + ";Session;path=/"
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
    var expires = "expires=" + d.toUTCString()
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"
}

export const login = createAsyncThunk(
    'auth/login',
    async (obj) => {
        const response = await client.post('/AppLogin/AppLoginValidation', obj)
        return response.data
    }
)

export const logout = createAsyncThunk(
    'auth/logout',
    async () => {
        const response = await client.post('/AppLogin/AppLoginRevoke')
        return response.data
    }
)

export const changeUser = createAsyncThunk(
    'auth/changeUser',
    async (obj) => {        
        const response = await client.post('/AspNetUsers/ChangeUser', obj)
        return response.data
    }
)

export const changeUserLanguage = createAsyncThunk(
    'auth/changeUserLanguage',
    async (obj) => {
        const response = await client.post('/AspNetUsers/ChangeUserLanguage', obj)
        return response.data
    }
)

export const recoveryPassword = createAsyncThunk(
    'auth/recoveryPassword',
    async (email) => {        
        const response = await client.post('/AspNetUsers/RecoveryPassword?email=' + email)
        return response.data
    }
)

// Slice
const sliceUser = createSlice({
    name: 'user',
    initialState: {
        user: getCookie("user") ? JSON.parse(getCookie("user")) : null
    },
    reducers: {},
    extraReducers: {
        [login.pending]: (state, action) => {
            state.status = 'loading'
            state = undefined
        },
        [login.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            state.user = getCookie("user") ? JSON.parse(getCookie("user")) : null            
        },
        [login.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.payload
        },
        [logout.pending]: (state, action) => {
            state.status = 'loading'
        },
        [logout.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            state.user = null
        },
        [logout.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.payload
        },
        [changeUser.pending]: (state, action) => {
            state.status = 'loading'
        },
        [changeUser.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            //window.location.href = window.location.href
        },
        [changeUser.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.payload
        },
        [changeUserLanguage.pending]: (state, action) => {
            state.status = 'loading'
        },
        [changeUserLanguage.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            //window.location.href = window.location.href
        },
        [changeUserLanguage.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.payload
        }
    }
})
export default sliceUser.reducer